/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum GroupTypeEnum {
    TECHNICIAN = 'TECHNICIAN',
    PLANNER = 'PLANNER',
    PARTNER = 'PARTNER',
    ADMIN = 'ADMIN',
    SUPPLIER = 'SUPPLIER',
    CUSTOMER = 'CUSTOMER'
}
